import { InjectionToken } from '@angular/core';

export const AUTO_BID_API_BASE_URL = new InjectionToken<string>('AUTO_BID_API_BASE_URL');
